import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { SpreadsheetCell } from "../../s25-spreadsheet/spreadsheet.service";

@TypeManagerDecorator("s25-ng-generic-table-render-html")
@Component({
    selector: "s25-ng-generic-table-render-html",
    template: `
        @if (!isHtml) {
            <div class="preview-snippet">{{ text }}</div>
        }
        @if (isHtml) {
            <div class="preview-snippet" [innerHTML]="text | safeHTML"></div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class GenericTableRenderHTMLComponent implements SpreadsheetCell {
    @Input() text: string;
    @Input() isHtml: boolean;

    getSpreadsheetCellValue(): ReturnType<SpreadsheetCell["getSpreadsheetCellValue"]> {
        return this.text;
    }
}
